export class RefundOptions {
  remainingERCCredits
  withPEO
  filedOnTime

  constructor(refundOptions = {}) {
    this.remainingERCCredits = refundOptions.remainingERCCredits ? Number(refundOptions.remainingERCCredits) : 0
    this.withPEO = refundOptions.withPEO ? Boolean(refundOptions.withPEO) : false
    this.filedOnTime = refundOptions.filedOnTime ? Boolean(refundOptions.filedOnTime) : false
  }
}